// alternative-dashboard/mappers/cashPositionMapper.ts
export interface DashboardAccountsCashPositionRawItem {
  accountid: string;
  transactiondatetime: string;
  balancecreditdebitindicator: string;
  balancecreditdebitamount: string;
  transactioncurrency: string;
  transactionPercentage: string;
}
export interface CashPositionPoint {
  name: string;
  value: number;
}

const RELEVANT_INDICATOR = "ClosingAvailable";

const formatPointLabel = (isoDate: string): string => {
  const date = new Date(isoDate);

  if (Number.isNaN(date.getTime())) return isoDate;

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
  });
};

export const mapCashPositionToChartPoints = (
  raw: DashboardAccountsCashPositionRawItem[] = [],
): CashPositionPoint[] => {
  return raw
    .filter((item) => item.balancecreditdebitindicator === RELEVANT_INDICATOR)
    .sort(
      (a, b) =>
        new Date(a.transactiondatetime).getTime() -
        new Date(b.transactiondatetime).getTime(),
    )
    .map((item) => ({
      name: formatPointLabel(item.transactiondatetime),
      value: Number(item.balancecreditdebitamount),
    }));
};

export const getLatestChangePercent = (
  raw: DashboardAccountsCashPositionRawItem[] = [],
) => {
  if (!raw.length) {
    return {
      percent: 0,
      direction: "up" as const,
    };
  }

  const latest = raw[raw.length - 1];

  const percent = Number(latest.transactionPercentage);

  return {
    percent: Math.abs(percent),
    direction: percent >= 0 ? "up" : ("down" as const),
  };
};

